import React, { useCallback } from "react";
import type { GQVatsQuery } from "graphql-sdk";
import { useTheme, DataTable, IconButton, Text } from "@venuepos/react-common";
import { StyleSheet } from "react-native";
import { formatDateTime } from "lib";
import { useAdminSession } from "../../session";
import type { AvailableLocale } from "locales";

export function VatRow({
    item,
    onDelete,
}: {
    item: GQVatsQuery["vats"]["data"][0];
    onDelete: (itemId: string) => void;
}) {
    const theme = useTheme();
    const [{ locale }] = useAdminSession(["locale"]);

    const handleDelete = useCallback(() => {
        onDelete(item.id);
    }, [item.id, onDelete]);

    return (
        <DataTable.Row>
            <DataTable.Cell>{item.name}</DataTable.Cell>
            <DataTable.Cell>
                <Text>{item.percentage} %</Text>
            </DataTable.Cell>
            <DataTable.Cell>
                {formatDateTime(item.createdAt, locale as AvailableLocale)}
            </DataTable.Cell>
            <DataTable.Cell numeric style={styles.iconColumn}>
                <IconButton
                    color={theme.colors.secondary}
                    name="delete"
                    onPress={handleDelete}
                />
            </DataTable.Cell>
        </DataTable.Row>
    );
}

const styles = StyleSheet.create({
    iconColumn: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 40,
    },
});
